module.exports = __webpack_public_path__ + "static/fail-banner-mobile-6173aabf1d43de9fdfeb494743878315.jpg";